import { css } from 'styled-components';

export const activeInputStyle = css<{ hasError?: boolean }>`
  box-shadow: inset 0px -3px 0px 0px ${(props) => (props.hasError ? props.theme.colors.error : '#000')};
  border-color: ${(props) => (props.hasError ? props.theme.colors.error : '#bfc1c1')};
`;

export const inputStyle = css<{ hasError?: boolean }>`
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  outline: none;
  border: 1px solid ${(props) => (props.hasError ? props.theme.colors.error : '#d8dada')};
  border-bottom: none;
  box-shadow: inset 0px -1px 0px 0px ${(props) => (props.hasError ? props.theme.colors.error : '#000')};
  padding: 12px 17px;
  font-size: 16px;
  :focus {
    ${activeInputStyle};
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/styles.ts